import React, { useEffect, useState } from "react";
import "../assets/Styles/form.css";
import logo from "../assets/Images/glitzz-logo.png";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import swal from "sweetalert";
import Select from "react-select";
import Spinner from "./Spinner";
import Swal2 from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";

const Forms = () => {
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, []);

  const [posts, setPosts] = useState([]);
  const [isLoading, SetLoading] = useState(false);
  const [select_skill, setSelectedSkill] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          "https://ats.glitzzstaffing.com/api/positions"
        );
        setPosts(data);
      } catch (err) {
        console.log(err);
      }
    };
    fetch();
  }, []);

  const [experience_year, setExperienceYear] = useState("");
  const [experience_month, setExperienceMonth] = useState("");
  const [show_current, setCtcCurrent] = useState(false);
  const [border_color, setBorder] = useState("");
  const [ctc, setCtc] = useState("");
  const [notice_period, setNoticePeriod] = useState("");
  const [expected, setExpected] = useState("");
  const [otherCalc, setOtherCalc] = useState("");
  const [desired_ctc, setDesiredCtC] = useState("");
  const [desired_ctc_Cala, setDesiredCtCCal] = useState("");
  const [resume, setResume] = useState();
  const [abilities, setAbilities] = useState("");
  const [description, setDescription] = useState("");

  const onChangeExpected = (e, otherCtc) => {
    setDesiredCtC(e.target.value);
    const value = parseInt(e.target.value);
    setExpected(e.target.value);
    let percentage;
    let expectedCTC;
    const tempCtc = otherCtc || ctc;

    if (tempCtc.length != 0) {
      percentage = (tempCtc * parseInt(e.target.value)) / 100;
      expectedCTC = parseInt(tempCtc) + percentage;
      setTotalCtc(<span className="form-type">{expectedCTC}</span>);
      setDesiredCtCCal(expectedCTC);
      setOtherCalc("");
    } else {
      setTotalCtc("");
    }

    if (value == "20" || value == "10") {
      // setShowDesc(true);
      setTotalCtc(<p className="smiley-face">&#128578;</p>);
      if (tempCtc.length != 0) {
        setOtherCalc(<span className="form-type">{expectedCTC}</span>);
      }
    } else if (value == "30") {
      setShowDesc(true);
      setTotalCtc(<p className="smiley-face"> &#128516;</p>);
      if (tempCtc.length != 0) {
        setOtherCalc(<span className="form-type">{expectedCTC}</span>);
      }
    } else if (value == "40") {
      setShowDesc(true);
      setBorder("orange");
      setTotalCtc(<p className="smiley-face">&#128513;</p>);
      if (tempCtc.length != 0) {
        setOtherCalc(<span className="form-type">{expectedCTC}</span>);
      }
    } else if (value == "50") {
      setShowDesc(true);
      setBorder("red");
      setTotalCtc(<p className="smiley-face">&#128517;</p>);
      if (tempCtc.length != 0) {
        setOtherCalc(<span className="form-type">{expectedCTC}</span>);
      }
    } else {
      setShowDesc(false);
    }
  };

  const onChangeExpected2 = (e) => {
    setDesiredCtC(e.target.value);
    if (e.target.value == "8k to 10k" || e.target.value == "10k to 15k") {
      setTotalCtc(<p className="smiley-face">&#128578;</p>);
      setShowDesc(false);
      setExpected(e.target.value);
    } else if (e.target.value == "15k to 20k") {
      setTotalCtc(<p className="smiley-face">&#128513;</p>);
      setShowDesc(true);
      setExpected(e.target.value);
      setBorder("purple");
    } else if (e.target.value == "20k to 25k") {
      setTotalCtc(<p className="smiley-face">&#128513;</p>);
      setShowDesc(true);
      setExpected(e.target.value);
      setBorder("orange");
    } else if (e.target.value == "25k to 30k") {
      setTotalCtc(<p className="smiley-face">&#128517;</p>);
      setShowDesc(true);
      setExpected(e.target.value);
      setBorder("red");
    } else {
      setTotalCtc("");
    }
  };

  let ExpectedCtC;
  if (experience_year == "0" && experience_month == "0") {
    ExpectedCtC = (
      <select className="pl-10" value={expected} onChange={onChangeExpected2}>
        <option value="">Select Expected CTC</option>
        <option value="8k to 10k">8k to 10k</option>
        <option value="10k to 15k">10k to 15k</option>
        <option value="15k to 20k">15k to 20k</option>
        <option value="20k to 25k">20k to 25k</option>
        <option value="25k to 30k">25k to 30k</option>
      </select>
    );
  } else {
    ExpectedCtC = (
      <select className="pl-10" value={expected} onChange={onChangeExpected}>
        <option value="">Select Expected CTC</option>
        <option value="10">10%</option>
        <option value="20">20%</option>
        <option value="30">30%</option>
        <option id="40%" value="40">
          40%
        </option>
        <option id="50%" value="50">
          50% or Greater than 50%
        </option>
      </select>
    );
  }

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [positions, setPositions] = useState("");
  const [Loading, setPostLoading] = useState(false);
  const [skillsoptions, setSkillsOptions] = useState([]);
  const [skills, setSkills] = useState([]);
  const [resumeData, setResumeData] = useState(null);
  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          "https://ats.glitzzstaffing.com/api/skills"
        );
        const options = data.map((item) => ({
          label: item.skills_name,
          value: item.id,
        }));
        setSkillsOptions(options);
        setPostLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    fetch();
  }, []);

  const [total_ctc, setTotalCtc] = useState("");
  const [desc, setShowDesc] = useState(false);

  const navigate = useNavigate();

  const onMainSubmit = async (e) => {
    e.preventDefault();
    SetLoading(true);

    const result = skills.map((obj) => obj.label).join(",");
    let Calulate =
      desired_ctc_Cala.length !== 0
        ? desired_ctc + "-" + desired_ctc_Cala
        : desired_ctc;

    // check if email exists & get full user data
    const userData = await checkEmailExists(email);

    const formData = new FormData();
    formData.append("dip_id", userData?.id || 0);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("gender", gender);
    formData.append("skills", result);
    formData.append("position", positions);
    formData.append("current_ctc", ctc.length === 0 ? 0 : ctc);
    formData.append("desired_ctc", Calulate);
    formData.append("totalexp", experience_month);
    formData.append("totalexp1", experience_year);
    formData.append("noticetime", notice_period);
    formData.append("file", resume);
    formData.append("description", description);
    formData.append("abilities", abilities);

    setPostLoading(true);

    try {
      const response = await axios.post(
        "https://ats.glitzzstaffing.com/api/staffguru",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      Swal2.fire({
        icon: "success",
        customClass: { container: "bd-position-popup" },
        title: "Your Application is Submitted at Zithas Technologies!",
        html: `<br /> We will review your resume and reach out to you accordingly. 
             Kindly retain application ${response.data.ID} for future reference. 
             <br /><br/> If you have any questions, feel free to reach out to our 
             <br/> HR Department at <a style="color:#5c0385;font-weight:600" href="tel:(+91) 720-388-2277">720-388-2277</a> 
             or via email at <a href="mailto:hr@zithas.com" style="color:#5c0385;font-weight:600">hr@zithas.com</a>`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Thank You !",
        className: "bd-position-popup",
      }).then(() => {
        navigate("/");
      });
    } catch (error) {
      console.error(error);
      Swal2.fire({
        icon: "error",
        text: "Something Went Wrong",
      });
      SetLoading(false);
    }
  };

  const [emailChecked, setEmailChecked] = useState(false);
  useEffect(() => {
    setEmailChecked(false);
  }, [email]);

  const checkEmailExists = async (email) => {
    try {
      const response = await fetch(
        `https://ats.glitzzstaffing.com/api/check-email/${email}`
      );
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        return data[0]; // return whole user object instead of just id
      }

      return null;
    } catch (error) {
      console.error("Error checking email:", error);
      return null;
    }
  };
  const showEmailPopup = async () => {
    if (email && !emailChecked) {
      SetLoading(true); // ✅ show loader

      try {
        const userData = await checkEmailExists(email);
        SetLoading(false); // ✅ hide loader

        if (userData) {
          Swal2.fire({
            icon: "warning",
            title: "Email Already Exists",
            text: "This email is already registered. Do you want to autofill your information?",
            showCancelButton: true,
            confirmButtonText: "Yes, Autofill",
            cancelButtonText: "No, Reset",
          }).then((result) => {
            if (result.isConfirmed) {
              setEmailChecked(true);
              setName(userData.name || "");
              setPhone(userData.phone || "");
              setGender(userData.gender || "");
              setPositions(userData.position || "");
              setCtc(userData.currentctc || "");
              setDesiredCtC(userData.desired_ctc || "");
              setExperienceYear(userData.totalexp || "");
              setExperienceMonth(userData.totalexp1 || "");
              setNoticePeriod(userData.noticetime || "");
              setDescription(userData.description || "");
              setAbilities(userData.abilities || "");
              setResumeData(userData.link || "");
              if (userData.currentctc) {
                setCtcCurrent(true);
              }

              if (userData?.desiredctc) {
                if (userData?.desiredctc?.includes("k")) {
                  onChangeExpected2({
                    target: { value: userData?.desiredctc },
                  });
                } else {
                  onChangeExpected(
                    {
                      target: {
                        value: userData?.desiredctc?.split("-")[0] || "",
                      },
                    },
                    userData.currentctc
                  );
                }
              }

              if (userData.skills) {
                const skillArray = userData.skills.split(",");
                setSkills(
                  skillsoptions.filter((sk) => skillArray.includes(sk.label))
                );
              }
            } else if (result.dismiss === Swal2.DismissReason.cancel) {
              window.location.reload();
            }
          });
        }
      } catch (error) {
        SetLoading(false);
        Swal2.fire(
          "Error",
          "Something went wrong while checking email.",
          "error"
        );
      }
    }
  };

  // const showEmailPopup = async () => {
  //   if (email && !emailChecked) {
  //     const userData = await checkEmailExists(email);
  //     console.log(userData);

  //     if (userData) {
  //       Swal2.fire({
  //         icon: "warning",
  //         title: "Email Already Exists",
  //         text: "This email is already registered. Do you want to autofill your information?",
  //         showCancelButton: true,
  //         confirmButtonText: "Yes, Autofill",
  //         cancelButtonText: "No, Reset",
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           setEmailChecked(true);
  //           setName(userData.name || "");
  //           setPhone(userData.phone || "");
  //           setGender(userData.gender || "");
  //           setPositions(userData.position || "");
  //           setCtc(userData.currentctc || "");
  //           setDesiredCtC(userData.desired_ctc || "");
  //           setExperienceYear(userData.totalexp || "");
  //           setExperienceMonth(userData.totalexp1 || "");
  //           setNoticePeriod(userData.noticetime || "");
  //           setDescription(userData.description || "");
  //           setAbilities(userData.abilities || "");

  //           if (userData.currentctc) {
  //             setCtcCurrent(true);
  //           }

  //           if (userData?.desiredctc) {
  //             if (userData?.desiredctc?.includes("k")) {
  //               onChangeExpected2({
  //                 target: {
  //                   value: userData?.desiredctc,
  //                 },
  //               });
  //             } else {
  //               onChangeExpected(
  //                 {
  //                   target: {
  //                     value: userData?.desiredctc?.split("-")[0] || "",
  //                   },
  //                 },
  //                 userData.currentctc
  //               );
  //             }
  //           }
  //           // onChangeExpected
  //           // setExpected(userData?.desiredctc?.split("-")[0] || "")

  //           // ✅ Autofill skills if API returns them as comma-separated string
  //           if (userData.skills) {
  //             const skillArray = userData.skills.split(",");

  //             setSkills(
  //               skillsoptions.filter((sk) => skillArray.includes(sk.label))
  //             );
  //           }
  //         } else if (result.dismiss === Swal2.DismissReason.cancel) {
  //           window.location.reload();
  //         }
  //       });
  //     }
  //   }
  // };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    showEmailPopup();
  };

  const handlePhoneFocus = () => {
    setTimeout(() => {
      showEmailPopup();
    }, 0);
  };

  return (
    <div className="">
      {Loading && <Spinner />}
      {isLoading && <Spinner />}
      <section>
        <div className="container">
          <div className="bd-service1 mb-30">
            <p className="main-logo-size text-center">
              <img className="logo-size" alt="img not appeared" src={logo} />
            </p>
          </div>
          <div className="main-bodys">
            <div className="">
              <div className="mt-3">
                <div>
                  <h4 className="text-white text-center">
                    Please Fill Out the Details & Submit the Application
                  </h4>
                </div>
                <form onSubmit={onMainSubmit}>
                  <div>
                    <div className="row mt-5 ">
                      <div className="col-md-3">
                        <div className="bd-contact-field">
                          <div>
                            <label>Name *</label>
                          </div>
                          <input
                            type="text"
                            className="form-reponsive"
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter Name"
                            value={name}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="bd-contact-field">
                          <div>
                            <label>Email Address *</label>
                          </div>
                          <input
                            type="email"
                            className="form-reponsive"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder=" Enter Email Address "
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="bd-contact-field">
                          <div>
                            <label>Phone Number *</label>
                          </div>
                          <input
                            type="text"
                            className="form-reponsive"
                            onChange={handlePhoneChange}
                            // onChange={(e) => setPhone(e.target.value)}
                            onFocus={handlePhoneFocus}
                            value={phone}
                            placeholder=" Enter Phone Number "
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="bd-contact-field">
                          <div>
                            <label> Select Gender *</label>
                          </div>
                          <select
                            aria-label=".form-select-sm example"
                            className="main-selection"
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                            required
                          >
                            <option>Select Gender</option>
                            <option value="Male"> Male </option>
                            <option value="Female"> Female </option>
                            <option value="other"> Other </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-5 pt-3">
                      <div className="col-md-3">
                        <div className="bd-contact-field">
                          <div>
                            <label> Select Position *</label>
                          </div>
                          <select
                            aria-label=".form-select-sm example"
                            className="main-selection"
                            value={positions}
                            onChange={(e) => setPositions(e.target.value)}
                            required
                          >
                            <option> Select Position</option>
                            {posts.map((jobs) => {
                              return (
                                <option value={jobs.positions_name}>
                                  {jobs.positions_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-9">
                        <div className="bd-contact-field">
                          <div>
                            <label>Skills *</label>
                          </div>
                          <Select
                            placeholder="Select Skills"
                            isMulti
                            options={skillsoptions}
                            value={skills}
                            onChange={(e) => {
                              setSkills(e);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-5 pt-3">
                      <div className="col-md-3">
                        <div className="bd-contact-field">
                          <div>
                            <label>Experience *</label>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <select
                                onChange={(e) => {
                                  setExperienceYear(e.target.value);
                                  if (
                                    (e.target.value == "0" &&
                                      experience_month == "0") ||
                                    (e.target.value == "0" &&
                                      experience_month.length == "0")
                                  ) {
                                    setCtcCurrent(false);
                                  } else {
                                    setCtcCurrent(true);
                                  }
                                }}
                                className="main-selection"
                                value={experience_year}
                                required
                              >
                                <option value=""> Year</option>
                                <option value="0">00</option>
                                <option value="1">01</option>
                                <option value="2">02</option>
                                <option value="3">03</option>
                                <option value="4">04</option>
                                <option value="5">05</option>
                                <option value="6">06</option>
                                <option value="7">07</option>
                                <option value="8">08</option>
                                <option value="9">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                              </select>
                            </div>
                            <div className="col-md-6 year-pt">
                              <select
                                onChange={(e) => {
                                  setExperienceMonth(e.target.value);
                                  if (
                                    (e.target.value == "0" &&
                                      experience_year == "0") ||
                                    (e.target.value == "0" &&
                                      experience_year.length == "0")
                                  ) {
                                    setCtcCurrent(false);
                                  } else {
                                    setCtcCurrent(true);
                                  }
                                }}
                                className="main-selection"
                                value={experience_month}
                                required
                              >
                                <option value=""> Month</option>
                                <option value="0">00</option>
                                <option value="1">01</option>
                                <option value="2">02</option>
                                <option value="3">03</option>
                                <option value="4">04</option>
                                <option value="5">05</option>
                                <option value="6">06</option>
                                <option value="7">07</option>
                                <option value="8">08</option>
                                <option value="9">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          show_current
                            ? "bd-current-open-form col-md-2 mb-25 resp-w-100"
                            : "display-none"
                        }
                      >
                        <div className="bd-contact-field">
                          <div>
                            <label>
                              Current CTC{" "}
                              <span style={{ fontSize: "10px" }}>(PM)</span>
                              <span style={{ color: "#ff4545" }}>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Current CTC"
                              value={ctc}
                              name="user_ctc"
                              onChange={(e) => setCtc(e.target.value)}
                              style={{ height: "45px" }}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="bd-contact-field">
                          <div
                            className={
                              show_current ? " resp-w-100" : " resp-w-100"
                            }
                          >
                            <label>
                              Expected CTC{" "}
                              <span style={{ color: "#ff4545" }}>*</span>
                            </label>
                            <div className="d-flex align-items-center">
                              <div className="w-100">{ExpectedCtC}</div>
                              <div
                                className={
                                  otherCalc.length == 0
                                    ? "display-none"
                                    : " mx-3 "
                                }
                              >
                                {otherCalc}
                              </div>

                              <div
                                className={
                                  total_ctc.length == 0
                                    ? "display-none "
                                    : " mx-2 "
                                }
                              >
                                {total_ctc}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 ">
                        <div className="bd-contact-field">
                          <div
                            className={
                              desc ? " mb-25 resp-w-100" : " mb-25 resp-w-100"
                            }
                          >
                            <label>
                              Notice Period{" "}
                              <span style={{ color: "#ff4545" }}>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Notice Period"
                              onChange={(e) => setNoticePeriod(e.target.value)}
                              value={notice_period}
                              name="user_period"
                              style={{ height: "45px" }}
                              required
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3 pt-2">
                      <div className="col-md-12">
                        <div className="bd-contact-field">
                          <div
                            className={
                              desc
                                ? "bd-current-open-form  mb-25 resp-w-100"
                                : "bd-current-open-form  mb-25 resp-w-100"
                            }
                          >
                            <label>
                              Upload CV{" "}
                              <span style={{ color: "#ff4545" }}>*</span>
                            </label>
                            <div className="row align-items-center">
                              <div className="col-md-10">
                                <input
                                  type="file"
                                  className="form-control"
                                  onChange={(e) => setResume(e.target.files[0])}
                                  required={!resumeData}
                                />
                              </div>

                              <div className="col-md-2">
                                {resumeData ? (
                                  <Link
                                    to={resumeData}
                                    className="download-btn"
                                    target="_blank"
                                    style={{ textDecoration: "none" }}
                                  >
                                    Download
                                  </Link>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-5 pt-3">
                      <div className="col-md-6">
                        <div className="bd-contact-field">
                          <div className=" mb-25 resp-w-100">
                            <label>
                              Tell us how your abilities align with the position
                              ?<span style={{ color: "#ff4545" }}>*</span>
                            </label>
                            <textarea
                              type="text"
                              value={abilities}
                              className="form-control"
                              onChange={(e) => setAbilities(e.target.value)}
                              style={{ fontSize: "14px" }}
                              placeholder="Tell us Your Abilities"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="bd-contact-field">
                          <div
                            className={
                              desc
                                ? "bd-current-open-form resp-w-100"
                                : "display-none"
                            }
                          >
                            <label>
                              Why do you deserve such a CTC Expectation?{" "}
                              <span style={{ color: "#ff4545" }}>*</span>
                            </label>
                            <textarea
                              type="text"
                              className={`form-control ${border_color}`}
                              onChange={(e) => setDescription(e.target.value)}
                              value={description}
                              style={{
                                fontSize: "14px",
                                borderColor: "#5c0385",
                              }}
                              placeholder="Enter Description"
                              required={desc ? true : false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-right mt-2">
                    <button className="btn-under">Apply Now</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Forms;
